import { render, staticRenderFns } from "./PageIntegrationTelegram.vue?vue&type=template&id=249d8b2b&scoped=true&"
import script from "./PageIntegrationTelegram.vue?vue&type=script&lang=js&"
export * from "./PageIntegrationTelegram.vue?vue&type=script&lang=js&"
import style0 from "./PageIntegrationTelegram.vue?vue&type=style&index=0&id=249d8b2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249d8b2b",
  null
  
)

export default component.exports